export const LOGIN_REMEMBER_PASSWORD = "LOGIN_REMEMBER_PASSWORD";
export const USER_TOKEN = "USER_TOKEN";
export const USER_INFO = "USER_INFO";
export const SMS_COUNTDOWN_TIMESTAMP = "SMS_COUNTDOWN_TIMESTAMP";
export const LOGIN_USER_ACCOUNT_INFO = "LOGIN_USER_ACCOUNT_INFO";

export const INTERNET_DELAY = "INTERNET_DELAY";
export const LINK_ACCOUNT_TOKEN = "LINK_ACCOUNT_TOKEN"
